<template>
  <v-menu
    v-if="hasAnyPermission('PATIENT_CREATE') || hasAnyPermission('PRESENTATION_CREATE')"
    v-model="menu"
    offset-y
    left
  >
    <template #activator="{ on }">
      <v-btn text v-on="on">
        <app-icon color="white">mdi-plus-box</app-icon>
        <app-icon color="white">mdi-menu-down</app-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-if="hasAnyPermission('PATIENT_CREATE')" class="v-list-item--link px-0">
        <patient-demographics-create-dialog @save="closeMenu" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import PatientDemographicsCreateDialog from '@/components/demographics/PatientDemographicsCreateDialog'
import { permissionsMixin } from '@/mixins/permissions'

export default {
  components: {
    PatientDemographicsCreateDialog
  },
  mixins: [permissionsMixin],
  data() {
    return {
      menu: false
    }
  },
  methods: {
    closeMenu() {
      this.menu = false
    }
  }
}
</script>
